import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AppLayout from "components/layout/AppLayout";
import ProtectedRoute from "components/routing/ProtectedRoute";
import Preloader from "components/ui/Preloader";
import { PATHS } from "data/paths";

const Home = lazy(() => import("pages/Home"));
const About = lazy(() => import("pages/About"));
const ScheduleCall = lazy(() => import("pages/ScheduleCall"));
const Terms = lazy(() => import("pages/Terms"));
const Policy = lazy(() => import("pages/Policy"));
const NotFound = lazy(() => import("pages/NotFound"));
const Login = lazy(() => import("pages/admin/Login"));
const NewsletterBlast = lazy(() => import("pages/admin/NewsletterBlast"));
const ServicePage = lazy(() => import("pages/services/ServicePage"));

function PageFallback() {
  return (
    <div style={{ minHeight: "40vh", display: "grid", placeItems: "center" }}>
      <Preloader />
    </div>
  );
}

export default function AppRouter() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<Home />} />
          <Route path={PATHS.about} element={<About />} />
          <Route path={PATHS.scheduleCall} element={<ScheduleCall />} />
          <Route path={PATHS.terms} element={<Terms />} />
          <Route path={PATHS.policy} element={<Policy />} />
          <Route path={PATHS.login} element={<Login />} />
          <Route
            path={PATHS.newsletterAdmin}
            element={
              <ProtectedRoute>
                <NewsletterBlast />
              </ProtectedRoute>
            }
          />
          <Route path="/:slug" element={<ServicePage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
